import { InjectionToken } from "@angular/core";

export const STATEFUL_CONTAINER_STATE_PROP = new InjectionToken<string>("STATEFUL_CONTAINER_STATE_PROP");
export const statefulContainerStatePropProvider = {
    provide: STATEFUL_CONTAINER_STATE_PROP,
    useValue: "statefulContainer",
};
